export default __webpack_public_path__ + "static/media/trbotperc.3d9c7643.mp3";